import { render, staticRenderFns } from "./MyAllies.vue?vue&type=template&id=c7872f58&scoped=true"
import script from "./MyAllies.vue?vue&type=script&lang=js"
export * from "./MyAllies.vue?vue&type=script&lang=js"
import style0 from "./MyAllies.vue?vue&type=style&index=0&id=c7872f58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7872f58",
  null
  
)

export default component.exports